import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class TwitterPublished extends Component {
  render() {
    const { message, link } = this.props;
    return (
      <div className="publish-facebook-preview clearfix">
        <div className="publish-facebook-preview-header clearfix">
          <div className="publish-facebook-preview-thumbnail">
            <img className="fit-parent" src="/assets/img/thumbnails/blitz_lol.png" role="presentation" />
          </div>
          <div className="publish-facebook-preview-info">
            <div className="publish-facebook-preview-user">Blitz Esports</div>
            {/* <div className="publish-facebook-preview-timestamp">{moment(date).fromNow()}</div> */}
          </div>
        </div>
        <div className="publish-facebook-preview-content">{message}</div>
        <div className="publish-facebook-preview-content">{link}</div>
      </div>
    );
  }
}

TwitterPublished.propTypes = {
  message: PropTypes.string,
  link: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/cms/entry/blitz/FacebookPublished.js